import { AxiosResponse, CancelToken } from "axios";
import http from "../../../../shared/http";
import { qs } from "../../../../utils";
import { ReadPersonTypesRequestDto, ReadPersonTypesResponseDto } from "./dtos";

export const listPersonTypes = async (
  { _query }: ReadPersonTypesRequestDto,
  cancelToken: CancelToken
): Promise<AxiosResponse<ReadPersonTypesResponseDto>> => {
  const query = qs.stringify(_query);
  return await http.get<ReadPersonTypesResponseDto>(`/person-types${query}`, {
    cancelToken,
  });
};
